import React from "react";
import { Form, TextArea } from "../../../primary";
import { SAVE_BTN } from "../../../../constants";
import { FormActions } from "../../../secondary/FormActions/FormActions";
import { allowEnterData } from "../../../../utils/patientsHelper";
import style from "./assessmentNotes.module.scss";
import { PERMISSIONS } from "../../../../constants/permissions";

export const NoteForm = ({ register, handleSubmit, doSubmit, reset, loading, disabled }) => (
  <div>
    <div className="pt-2 pb-2">
      <span className={style.notes_title}>Notes:</span> <span className={style.notes_sub_title}>(Optional)</span>
    </div>

    <Form onSubmit={handleSubmit(doSubmit)} requiredPermission={PERMISSIONS.NOTES} disabled={disabled}>
      <TextArea
        classes={{ inputClassName: `${style.textarea_box} w-100 mb-2` }}
        rows={3}
        id="notesField"
        name="notes"
        placeholder="Add notes here"
        validator={register()}
        onKeyDown={(e) => allowEnterData(e)}
      />

      <FormActions
        align="end"
        primaryLabel={SAVE_BTN}
        primaryId="updateNotes"
        primaryType="submit"
        primaryLoading={loading}
        secondaryLabel="Clear"
        secondaryId="updateCancel"
        onSecondaryClick={() => reset()}
      />
    </Form>
  </div>
);
